module.exports = __webpack_public_path__ + "img/help-ot1.ca0e416b.png";